import { Lock } from "@mui/icons-material";
import { Alert, Avatar, Box, Button, Paper, TextField, Typography } from "@mui/material";
import { getAuth, signInWithEmailAndPassword } from "firebase/auth";
import { useState } from "react";
import { app } from "./Components/FirebaseConfig.js";

// INITIALIZE AUTH
const auth = getAuth(app);

// LOGIN COMPONENT
export default function Login({ on_login }) {
  const [username, set_username] = useState("");
  const [password, set_password] = useState("");
  const [alert, set_alert] = useState(false);

  const handle_login = (e) => {
    e.preventDefault();
    signInWithEmailAndPassword(auth, username, password)
      .then((userCredential) => {
        // Signed in successfully
        const user = userCredential.user;
        on_login(user.uid);
      })
      .catch((error) => {
        if (!alert) {
          set_alert(true);
          const setTimeoutID = setTimeout(() => {
            set_alert(false);
            clearTimeout(setTimeoutID);
          }, 5000);
        }
      });
  };

  return (
    <Box sx={{ display: "flex", justifyContent: "center", alignItems: "center", height: "90vh" }}>
      <Paper
        variant="outlined"
        className="loginAnimation"
        component="form"
        onSubmit={handle_login}
        noValidate
        autoComplete="off"
        sx={{
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          padding: 3,
          width: 450,
          borderStyle: "solid",
          borderColor: "primary.main",
          borderWidth: 5,
          borderRadius: 5,
        }}
      >
        <Avatar sx={{ p: 3.5, bgcolor: "primary.main" }}>
          <Lock fontSize="large" />
        </Avatar>
        <Typography
          component="h1"
          sx={{ color: "primary.main", m: 2, letterSpacing: 5, width: "100%", display: "flex", justifyContent: "center" }}
          variant="h5"
        >
          TRADING MONITOR
        </Typography>
        <TextField
          error={alert}
          sx={{ m: 1 }}
          fullWidth
          label="Username"
          variant="outlined"
          value={username}
          onChange={(e) => set_username(e.target.value)}
        />
        <TextField
          error={alert}
          sx={{ m: 1 }}
          fullWidth
          label="Password"
          type="password"
          variant="outlined"
          value={password}
          onChange={(e) => set_password(e.target.value)}
        />
        <Button disableElevation fullWidth variant="contained" size="large" color="primary" type="submit" sx={{ m: 2 }}>
          LOGIN
        </Button>
        {alert && (
          <Alert className="errorAnimation" severity="error">
            Wrong Username and Password
          </Alert>
        )}
      </Paper>
    </Box>
  );
}
